module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/en-盛泰荣誉png.f73c9296.png";